// extracted by mini-css-extract-plugin
export default {"titleSection":"titleSection_titleSection__+bhxa"};